// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Io","fullWidth":"e_Jo"};